import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/premium-bg-white.svg'
import _imports_1 from '@/assets/icons/free-member-bg-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-0cb5b242"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-h-full tw-flex-col-between" }
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-gap-1 tw-pb-3 tw-box-border tw-border-b-dashed-custom" }
const _hoisted_3 = { class: "tw-flex-row-between tw-gap-2" }
const _hoisted_4 = { class: "tag tw-rounded-full tw-flex tw-items-center tw-justify-center tw-w-[18px] tw-h-[18px]" }
const _hoisted_5 = {
  key: 0,
  class: "tw-w-[16px] tw-h-[16px] tw-object-contain",
  src: _imports_0
}
const _hoisted_6 = {
  key: 1,
  class: "tw-w-[16px] tw-h-[16px] tw-object-contain",
  src: _imports_1
}
const _hoisted_7 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-items-start tw-gap-2" }
const _hoisted_8 = { class: "tw-flex-row-between tw-gap-2 tw-flex-wrap" }
const _hoisted_9 = { class: "tw-flex tw-items-center tw-gap-1" }
const _hoisted_10 = { class: "tw-w-full" }
const _hoisted_11 = { class: "tw-w-full tw-flex-row-between" }
const _hoisted_12 = { class: "tw-rounded-full tw-w-[16px] tw-h-[16px] tw-flex tw-items-center tw-justify-center" }

import moment from "moment";
import { useRouter } from "vue-router";
import { ref, onMounted, nextTick, onUnmounted, computed } from "vue";

import Text from "@/core/components/ui/general/Text.vue";
import ChipState from "@/core/components/common/ChipState.vue";
import CommercialChip from "@/core/uni-components/Chips/CommercialChip.vue";
import ResidentialChip from "@/core/uni-components/Chips/ResidentialChip.vue";
import HistoricalProjectChip from "@/core/uni-components/Chips/HistoricalProjectChip.vue";
import { ProjectJobStatusEnum } from "@/core/enums/ProjectsEnum";
import { PROJECT_DETAILS_ROUTE } from "../routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'DraftHistoricalProjectCard ',
  props: {
  job: {
    type: Object,
    required: true,
  },
  hasProgressBar: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const router = useRouter();

const props = __props;

const descriptionElement = ref(null) as any;
const isOverflowing = ref(false);

const projectStatusItems = ref([
  {
    text: "All",
    value: "",
    icon: "trade-network-list",
  },
  {
    text: "Awaiting estimates",
    value: ProjectJobStatusEnum.AWAITING_QUOTES,
    icon: "awaiting-estimates-icon",
  },
  {
    text: "Estimates received",
    value: ProjectJobStatusEnum.QUOTES_RECEIVED,
    icon: "estimates-receive-icon",
  },
  {
    text: "In progress",
    value: ProjectJobStatusEnum.IN_PROGRESS,
    icon: "in-progress-icon",
  },
  {
    text: "Cancelled",
    value: ProjectJobStatusEnum.CANCELLED,
    icon: "cancelled-icon",
  },
]);

const checkOverflow = () => {
  nextTick(() => {
    if (descriptionElement.value) {
      const el = descriptionElement.value;
      isOverflowing.value = el.scrollHeight > el.clientHeight;
      console.log(
        "Scroll Height:",
        el.scrollHeight,
        "Client Height:",
        el.clientHeight,
        "Is Overflowing:",
        isOverflowing.value
      );
    }
  });
};

// Method to calculate elapsed time
const calculateElapsedTime = (date: string): string => {
  const now = moment();
  const createdDate = moment(date);

  const seconds = now.diff(createdDate, "seconds");
  const minutes = now.diff(createdDate, "minutes");
  const hours = now.diff(createdDate, "hours");
  const days = now.diff(createdDate, "days");
  const weeks = now.diff(createdDate, "weeks");
  const months = now.diff(createdDate, "months");
  const years = now.diff(createdDate, "years");

  if (years > 0) {
    return `${years} Year${years > 1 ? "s" : ""}`;
  } else if (months > 0) {
    return `${months} Month${months > 1 ? "s" : ""}`;
  } else if (weeks > 0) {
    return `${weeks} Week${weeks > 1 ? "s" : ""}`;
  } else if (days > 0) {
    return `${days} Day${days > 1 ? "s" : ""}`;
  } else if (hours > 0) {
    return `${hours} Hrs${hours > 1 ? "" : ""}`;
  } else if (minutes > 0) {
    return `${minutes} Min${minutes > 1 ? "s" : ""}`;
  } else {
    return `${seconds} Sec${seconds > 1 ? "s" : ""}`;
  }
};

// Reactive reference to hold the elapsed time
const elapsedTime = ref(calculateElapsedTime(props.job?.dateCreated));

// Update the elapsed time every minute
const realTimeSetInterval = setInterval(() => {
  elapsedTime.value = calculateElapsedTime(props.job?.dateCreated);
}, 1000);

const getProjectStatus = (type: string) => {
  const projectStatus = projectStatusItems.value.find(
    (item) => item.value === type
  ) as any;
  return projectStatus?.text;
};

const onClickProject = (value: string, projectType: string) => {
  router.push({ name: PROJECT_DETAILS_ROUTE, params: { refId: value } });
  // if (projectType == "video consultation") {
  //   const routerData = router.resolve({
  //     name: PROJECT_DETAILS_ROUTE,
  //     params: { refId: value },
  //   });
  //   window.open(routerData.href, "_blank");
  // }
};

onMounted(() => {
  checkOverflow();
  window.addEventListener("resize", checkOverflow);
});
onUnmounted(() => {
  clearInterval(realTimeSetInterval);
});

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: _normalizeClass(["tw-min-h-[250px] tw-bg-white tw-rounded-[20px] tw-shadow-none tw-cursor-pointer tw-p-4 tw-box-borders tw-h-auto", 
      props.job?.userWorkstation_subscription
        ? 'premium-job-gradient'
        : 'free-job-gradient'
    ])
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ChipState, {
              class: "tw-relative tw-z-10 !tw-justify-start !tw-p-[0] !tw-gap-2",
              hasCustomLabel: true,
              bgColor: "transparent",
              hasShadow: false
            }, {
              prefix: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  (props.job?.userWorkstation_subscription)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                    : (_openBlock(), _createElementBlock("img", _hoisted_6))
                ])
              ]),
              "custom-label": _withCtx(() => [
                _createVNode(Text, {
                  variant: "span",
                  whiteSpace: "nowrap"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.job?.userWorkstation_subscription ? "PREMIUM" : "FREE") + " ", 1),
                    _createVNode(Text, {
                      variant: "span",
                      whiteSpace: "nowrap",
                      textColor: "#FFA500"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("PROPERTY MEMBER")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(Text, { variant: "span" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(elapsedTime.value), 1),
                _createVNode(Text, {
                  variant: "span",
                  textColor: "#8587A4"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" ago")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(Text, {
            variant: "h5",
            textAlign: "left",
            whiteSpace: "noWrap",
            class: "tw-overflow-hidden tw-text-ellipsis"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.job?.name), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(HistoricalProjectChip),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(Text, { variant: "span" }, {
                default: _withCtx(() => [
                  _createTextVNode(" 1 "),
                  _createVNode(Text, {
                    variant: "span",
                    textColor: "#8587A4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Property")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_divider, { direction: "vertical" }),
              _createVNode(ResidentialChip)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(Text, {
              ref_key: "descriptionElement",
              ref: descriptionElement,
              variant: "span",
              textWeight: "400",
              textAlign: "left",
              lineHeight: "20px",
              textColor: "rgba(12, 15, 74, 0.5)",
              class: "description-text tw-overflow-hidden tw-text-ellipsis",
              innerHTML: __props.job?.description
            }, null, 8, ["innerHTML"]),
            (isOverflowing.value)
              ? (_openBlock(), _createBlock(Text, {
                  key: 0,
                  textColor: "#4F55F0",
                  variant: "span",
                  textWeight: "400"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Read More")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["tw-w-full tw-flex tw-flex-col tw-gap-1", {
          'tw-border-t-dashed-custom tw-pt-3 tw-box-border': __props.hasProgressBar,
        }])
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(ChipState, {
              label: "Details",
              bgColor: "#FAA500",
              textColor: "#FFF",
              class: "!tw-rounded-full"
            }, {
              postfix: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-chevron-right",
                    color: "#FFF",
                    size: "x-small"
                  })
                ])
              ]),
              _: 1
            })
          ])
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})